import { CommonModule } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	CUSTOM_ELEMENTS_SCHEMA,
	input,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';

import { TagComponent } from '@valk-nx/components/ui-tag/src/lib/tag';

import { LinkListItem } from './link-list.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-link-list`,
	templateUrl: './link-list.component.html',
	imports: [
		AngularSvgIconModule,
		CommonModule,
		RouterModule,
		TagComponent,
		TranslatePipe,
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LinkListComponent {
	linkListItems = input.required<LinkListItem[]>();

	showIcons = input(true);
	showDivider = input(true);
	showBorderTop = input(false);
	useChevron = input(false);

	className = input('');

	// Returns properly encoded URL for routing to avoid encoding issues
	getRouterLink(url: string): string {
		const decodedUrl = decodeURIComponent(url);

		// Handle relative paths
		if (decodedUrl.startsWith('./') || decodedUrl.startsWith('../')) {
			return decodedUrl;
		}

		// Handle absolute paths starting with /
		if (decodedUrl.startsWith('/')) {
			return decodedUrl;
		}

		// Handle root paths (prepend /)
		return '/' + decodedUrl;
	}
}
